import { render, staticRenderFns } from "./staff-info.vue?vue&type=template&id=0079cd52&scoped=true&"
import script from "./staff-info.vue?vue&type=script&lang=js&"
export * from "./staff-info.vue?vue&type=script&lang=js&"
import style0 from "./staff-info.vue?vue&type=style&index=0&id=0079cd52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079cd52",
  null
  
)

export default component.exports